import React, { useState, useEffect, useRef } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import renderReviewStars from './starRatingFunction'
import { Waypoint } from 'react-waypoint'
import styles from './Marketplace.module.scss'
import styled, { css } from 'styled-components'

import { Container, VerticalPad, ProductH3 } from '../theme/default/base'

const Header = styled(ProductH3)`
  text-align: center;
`

const FaqMain = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const ProductFaq = styled.div`
  padding: 10px 0;
  padding-right: 10px;
  width: 50%;

  img {
    width: 100%;
  }

  ${(props) => props.theme.media.phone`
    width: 100%;
    padding-right: 0;
  `}
`

const FaqHeader = styled.h4`
  font-size: 1.1rem;
`

const Center = styled.div`
  text-align: center;
`

const AllButton = styled.button`
  border: 0;
  background-color: transparent;
  text-align: center;
  margin: 10px auto;

  font-size: 1.1rem;
  color: ${(props) => props.theme.colors.primary};
`

const ReviewMain = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const ProductReview = styled.div`
  width: 50%;

  ${(props) => props.theme.media.phone`
    width: 100%;
  `}

  .review_tagline {
    font-weight: 500;
    font-size: 1rem;
    padding-left: 5px;
  }

  padding: 10px;

  img {
    margin-bottom: 10px;
  }

  h5 {
    margin: 0 0 5px;
    color: $theme-black;
    font-size: 1.2rem;
  }

  .member_since,
  .member_stars {
    margin-bottom: 5px;

    & > span:first-child,
    & > span:first-child {
      color: $theme-black;
      font-weight: 500;
    }
  }

  .cwp_review_stars span:first-child {
    font-weight: 600;
  }

  .cwp_review_comment {
    font-size: 14px !important;
    margin-top: 10px;
  }

  .checked {
    color: #edab1e;
  }
`
/*

  .cwp_review_faq_card_scroll {
    max-height: 430px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .profile_category_title {
    padding: 15px 0;
  }

  .cwp_faq_inner_main .panel {
    min-height: initial;
  }

  .cwp_review_inner_main {
    .cwp_review_inner_card {
    }

    .cwp_review_inner_card:not(:last-child){
      margin-bottom: 20px;
    }
  }
*/

const Comment = styled.div`
  font-size: 14px !important;
  margin-top: 10px;
`

function formatReviewName(review) {
  if (review?.name) {
    return review.name
  }
  const fn = review.fin_user?.first_name || ''
  const ln = review.fin_user?.last_name || ''
  return `${fn} ${ln}`.trim() || 'Anonymous'
}

@inject('store')
@observer
class ChangeSection extends React.Component {
  static propTypes = {
    product: PropTypes.object,
    references: PropTypes.object,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
    setSectionList: PropTypes.func
  }

  state = {
    reviews: [],
    faqs: [],
    sections_list: []
  }

  async componentDidMount() {
    const { store } = this.props
    const reviews = this.props.product.reviews
    const faqs = this.props.product.faqs
    const total_stars = (reviews || []).reduce(
      (acc, currValue) => acc + Number(currValue.star_rating),
      0
    )
    store.product_details = {
      review_count: reviews?.length || 0,
      faq_count: faqs?.length || 0,
      avg_stars: total_stars / (reviews?.length || 1)
    }
    this.setState({
      reviews,
      faqs,
      sections_list: await this.props.setSectionList()
    })
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product) {
      const { store } = this.props
      const reviews = this.props.product.reviews
      const faqs = this.props.product.faqs
      const total_stars = (reviews || []).reduce(
        (acc, currValue) => acc + Number(currValue.star_rating),
        0
      )
      store.product_details = {
        review_count: reviews?.length || 0,
        faq_count: faqs?.length || 0,
        avg_stars: total_stars / (reviews?.length || 1)
      }
      this.setState({
        reviews,
        faqs,
        sections_list: await this.props.setSectionList()
      })
    }
  }

  render() {
    const content = []
    const { reviews, faqs } = this.state

    if (reviews && (reviews?.length || 0) > 0) {
      content.push(
        <Waypoint
          key={'reviews'}
          topOffset="152px"
          onEnter={(obj) => {
            this.props.onEnter(obj, 'reviews')
          }}
          onLeave={(obj) => {
            this.props.onLeave(
              obj,
              this.state.sections_list[
                this.state.sections_list.indexOf('reviews') + 1
              ] || null
            )
          }}
        >
          <div id="reviews" key="reviews">
            <Review
              reviews={reviews}
              reference={this.props.references.review}
            />
          </div>
        </Waypoint>
      )
    }
    if (faqs && faqs.length > 0) {
      content.push(
        <Waypoint
          key="faq"
          topOffset="152px"
          onEnter={(obj) => {
            this.props.onEnter(obj, 'faq')
          }}
          onLeave={(obj) => {
            this.props.onLeave(obj, null)
          }}
        >
          <div id="faq" key="faq">
            <FAQ faqs={faqs} reference={this.props.references.faq} />
          </div>
        </Waypoint>
      )
    }
    if (content.length === 0) {
      return null
    }
    return content
  }
}

@inject('store')
@observer
class Review extends React.Component {
  static propTypes = {
    reviews: PropTypes.array,
    reference: PropTypes.object
  }

  state = {
    showNext: 4
  }

  handleBrokenImg(e) {
    e.target.src = '/assets/images/no-image.jpg'
  }

  renderReviewCard() {
    const { reviews } = this.props
    const { showNext } = this.state
    if (reviews && reviews.length === 0) {
      return (
        <div className="text-center">
          <span className={styles.no_review_heading}> No Reviews Yet </span>
        </div>
      )
    }
    return reviews.slice(0, showNext).map((review) => {
      const profileImg =
        review.fin_user?.profile_media?.media_thumbnail ||
        '/assets/images/no-image.jpg'
      const name = formatReviewName(review)
      return (
        <ProductReview key={review.id}>
          <div>
            <img
              className="pro-pic"
              src={profileImg}
              onError={this.handleBrokenImg}
              alt="pro_pic"
              height="45px"
              width="45px"
              style={{ marginRight: '10px' }}
            />
            <span>{name}</span>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className={styles.member_stars}>
                {renderReviewStars(review.star_rating)}
              </div>
              <div>
                <span className={styles.review_tagline}>{review.tag_line}</span>
              </div>
              <Comment>
                <Description description={review.description} />
              </Comment>
            </div>
          </div>
        </ProductReview>
      )
    })
  }

  handleClick = () => {
    this.setState({ showNext: this.state.showNext + 20 })
  }

  render() {
    const { reviews } = this.props
    const { showNext } = this.state
    return (
      <Container>
        <VerticalPad>
          <section ref={this.props.reference}>
            <Header>Hear what our members have to say</Header>
            <ReviewMain>{this.renderReviewCard()}</ReviewMain>
            {reviews.length > 2 && !(reviews.length < showNext + 1) && (
              <Center>
                <AllButton onClick={this.handleClick}>
                  See all members reviews
                </AllButton>
              </Center>
            )}
          </section>
        </VerticalPad>
      </Container>
    )
  }
}

const FaqController = ({ faqObj }) => {
  const [full, setFull] = useState(false)
  const [showToggle, setToggle] = useState(false)
  const ref = useRef(null)
  const maxHeight = 150
  useEffect(() => {
    if (ref.current.clientHeight > maxHeight) {
      setToggle(true)
    }
  })
  return (
    <ProductFaq key={faqObj.id} full={full}>
      <div>
        <FaqHeader className={styles.panel_title}>{faqObj.question}</FaqHeader>
      </div>
      <div id={faqObj.id}>
        <DescriptionWrapper
          full={full}
          showToggle={showToggle}
          ref={ref}
          maxHeight={maxHeight}
        >
          <Description description={faqObj.answer} />
        </DescriptionWrapper>
      </div>
      {showToggle && (
        <LessMoreRow>
          {full && (
            <ShowLessMore onClick={() => setFull(false)}>
              Show Less
            </ShowLessMore>
          )}
          {!full && (
            <ShowLessMore onClick={() => setFull(true)}>Show More</ShowLessMore>
          )}
        </LessMoreRow>
      )}
    </ProductFaq>
  )
}
FaqController.propTypes = {
  faqObj: PropTypes.object
}

@inject('store')
@observer
class FAQ extends React.Component {
  static propTypes = {
    faqs: PropTypes.array,
    reference: PropTypes.object
  }

  state = {
    showNext: 4
  }

  renderFAQCard() {
    const { faqs } = this.props
    const { showNext } = this.state
    if (faqs && faqs.length === 0) {
      return (
        <div className="text-center">
          <span className={styles.no_review_heading}> No FAQs Yet </span>
        </div>
      )
    }
    return faqs
      .slice(0, showNext)
      .map((faqObj) => <FaqController key={faqObj.id} faqObj={faqObj} />)
  }

  handleClick = () => {
    this.setState({ showNext: this.state.showNext + 20 })
  }

  render() {
    const { faqs } = this.props
    const { showNext } = this.state
    return (
      <Container>
        <VerticalPad>
          <section ref={this.props.reference}>
            <Header>Questions & Answers</Header>
            <FaqMain>{this.renderFAQCard()}</FaqMain>
            {faqs && faqs.length > 2 && !(faqs.length < showNext + 1) && (
              <Center>
                <AllButton onClick={this.handleClick}>
                  See all members questions and answers
                </AllButton>
              </Center>
            )}
          </section>
        </VerticalPad>
      </Container>
    )
  }
}

const LessMoreRow = styled.div`
  margin: 10px 0;
`

const ShowLessMore = styled.button`
  border: 0;
  background: transparent;
  margin-left: 0;
  padding-left: 0;
`

const DescriptionWrapper = styled.div`
  overflow: hidden;
  position: relative;

  ${(props) =>
    !props.full &&
    props.showToggle &&
    css`
      max-height: ${(props) => props.maxHeight}px;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50%;
        background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0.1) 100%
        );
      }
    `}
`

const Description = ({ description }) => (
  <div dangerouslySetInnerHTML={{ __html: description }}></div>
)

Description.propTypes = {
  description: PropTypes.string
}

export default ChangeSection
